import { useContext } from "react";

import { AlertsContext } from "./index";

export function useAlerts() {
  return useContext(AlertsContext);
}
